<template>
  <div class="mt-15 text-center">
    <h1 class="player-registration-confirmation__text">
      {{ $t("player_registration.registration_complete") }}!
    </h1>
    <h2 class="player-registration-confirmation__text">
      {{ renderRegistrationSubtitle }}
    </h2>
    <button
      @click="handleRedirectionToDashboard"
      type="button"
      class="mt-5 font-weight-medium primary--text"
    >
      {{ $t("player_registration.continue_to_fan_dashboard") }}
    </button>
  </div>
</template>

<script>
import { Routes } from "../../../router/Routes";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { i18n } from "../../../plugins/i18n";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PlayerRegistrationFormConfirmation",
  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistrationInfo",
      "playerRegistration",
      "playerRegistrationDetails"
    ]),
    renderRegistrationSubtitle() {
      return `${
        this.playerRegistration.value === "new_player"
          ? this.playerRegistrationDetails.playerAnswerList?.[0].answers[0] +
            " " +
            this.playerRegistrationDetails.playerAnswerList?.[1].answers[0]
          : this.playerRegistration.name
      } ${i18n.tc("player_registration.is_registered_for")} ${
        this.playerRegistrationInfo.registrationName
      }`;
    }
  },

  methods: {
    ...mapActions(ModuleTypes.PLAYER_REGISTRATION, [
      "fetchPlayerRegistrationDetails"
    ]),
    handleRedirectionToDashboard() {
      this.$router.push(Routes.TODAY.path);
    }
  },

  mounted() {
    this.fetchPlayerRegistrationDetails({
      registrationId: this.$route.params.registrationId,
      playerId: this.$route.params.playerId
    });
  }
};
</script>

<style scoped>
.player-registration-confirmation__text {
  font-size: 26px;
  font-weight: var(--font-weight-regular);
  color: var(--dark-color);
}
</style>
